<template>
  <v-container fluid class="pa-0">
    <div id="map" class="map"></div>
    <i id="mapSpinner" class="fa fa-spinner fa-spin map-spinner"></i>

    <vue-draggable-resizable
      style="border: none; opacity: 0.8;"
      :resizable="false"
      :x="10"
      :h="70"
      :w="400"
      :z="1"
      :parent="true"
      :drag-handle="'.drag-handle'"
      class="hidden-xs-only"
    >
      <v-card outline class="mx-auto" style="top: 56px">
        <v-system-bar color="#e60085" class="drag-handle">
          <v-icon color="#fff">mdi-information-outline</v-icon>
          <span style="color: #fff">Legenda</span>
          <v-spacer></v-spacer>
          <div style="color: #fff">
            <v-btn text color="white" class="white--text" @click="dataTable = true">
              Lista
              <v-icon color="white">mdi-view-headline</v-icon>
            </v-btn>
          </div>
        </v-system-bar>
        <v-card-text class="ma-0 pa-0">
          <div v-html="legend" style="display:flex; wdith: 100%; height: 30px"></div>
        </v-card-text>
      </v-card>
    </vue-draggable-resizable>
    <v-card
      outline
      class="mx-auto d-sm-none"
      style="position: fixed;bottom: 0;width: 100%; z-index: 1000"
    >
      <v-system-bar color="#e60085">
        <v-icon color="#fff">mdi-information-outline</v-icon>
        <span style="color: #fff">Legenda</span>
        <v-spacer></v-spacer>
        <div style="color: #fff">
          <v-btn text color="white" class="white--text" @click="dataTable = true">
            Lista
            <v-icon color="white">mdi-view-headline</v-icon>
          </v-btn>
        </div>
      </v-system-bar>
      <v-card-text class="ma-0 pa-0">
        <div v-html="legend" style="display:flex; wdith: 100%; height: 30px"></div>
      </v-card-text>
    </v-card>
    <!-- grid dialog -->
    <v-dialog v-model="dataTable" fullscreen hide-overlay transition="dialog-bottom-transition">
      <v-card>
        <v-toolbar color="#45a3c2">
          <v-btn icon dark @click="dataTable = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
          <v-toolbar-title style="color:#fff">Poziom wód</v-toolbar-title>
        </v-toolbar>
        <v-simple-table dense fixed-header>
          <template v-slot:default>
            <thead>
              <tr>
                <th class="text-left">Nazwa czujnika</th>
                <th class="text-left">Poziom</th>
                <th class="text-left">Poziom ostrzegawczy</th>
                <th class="text-left">Poziom alarmowy</th>
                <th class="text-left">Data ostatniego odczytu</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="item in sensorData.features" :key="item.properties.objectid">
                <td>{{ item.properties.name }}</td>
                <td :style="'color:' + getMarkerColor(item)">{{ item.properties.water_level }}</td>
                <td>{{ item.properties.warning_level }}</td>
                <td>{{ item.properties.alarm_level }}</td>
                <td>{{ new Date(item.properties.assessmentdatetime).toLocaleString() }}</td>
              </tr>
            </tbody>
          </template>
        </v-simple-table>
      </v-card>
    </v-dialog>
    <div id="popupPanel" class="popup-panel d-sm-none"></div>
  </v-container>
</template>

<script>
import Vue from "vue";
import "../tools/EasyButton";
import axios from "axios";
import L from "leaflet";
import "../tools/Map";
import "../tools/icons/WaterLevelIcon";
import VueDraggableResizable from "vue-draggable-resizable";
import "leaflet.markercluster";
import "leaflet.locatecontrol";
import WaterLevelPopupVue from "./WaterLevelPopup.vue";

export default {
  name: "waterlevel",
  components: { VueDraggableResizable },
  data() {
    return {
      gradesColors: ["#228b22", "#ff8c00", "#e60008"],
      polling: null,
      changeBouncer: null,
      map: null,
      sensorData: null,
      airSensorLayer: null,
      airSensorClusterGroup: null,
      dataTable: false
    };
  },
  mounted() {
    this.initMap();
    this.loadData();
    this.pollData();
  },
  beforeDestroy() {
    clearInterval(this.polling);
  },
  computed: {
    legend() {
      let div = "";
      let gradesLabel = ["normalny", "podwyższony", "alarmowy"];

      for (var i = 0; i < gradesLabel.length; i++) {
        div +=
          "<div style='padding-top: 4px; padding-bottom:4px; display:inline-block; width: 100%; text-align:center; color:white;background-color:" +
          this.gradesColors[i] +
          ";'>" +
          gradesLabel[i] +
          "</div>";
      }
      div += "</div>";
      return div;
    }
  },
  watch: {
    sensorData() {
      if (this.airSensorLayer)
        this.airSensorClusterGroup.removeLayer(this.airSensorLayer);
      this.airSensorLayer = L.geoJson(this.sensorData, {
        pointToLayer: (feature, latlng) => {
          let markerColor = this.gradesColors[0];

          if (feature.properties.water_level > feature.properties.warning_level) {
            markerColor = this.gradesColors[1];
          }

          if (feature.properties.water_level > feature.properties.alarm_level) {
            markerColor = this.gradesColors[2];
          }

          return L.marker(latlng, {
            icon: L.waterLevelIcon({
              color: markerColor
            })
          });
        },
        onEachFeature: (feature, layer) => {
          let PopupCont = Vue.extend(WaterLevelPopupVue);
          //debugger;
          let popup = new PopupCont({
            propsData: {
              sensordata: feature.properties
            }
          });

          let popupRef = popup;
          let that = this;

          layer.on("click", function(e) {
            Map.showPopup(that.map, that.$vuetify.breakpoint.name, popup, e, function() {
              return that.getMarkerColor(feature);
            });
          });
        }
      });

      this.airSensorClusterGroup.addLayer(this.airSensorLayer);
    }
  },
  methods: {
    getMarkerColor(feature) {
      let markerColor = this.gradesColors[0];

      if (feature.properties.water_level > feature.properties.warning_level) {
        markerColor = this.gradesColors[1];
      } else if (feature.properties.water_level > feature.properties.alarm_level) {
        markerColor = this.gradesColors[2];
      }

      return markerColor;
    },
    pollData() {
      this.polling = setInterval(() => {
        this.loadData();
      }, 60000);
    },
    loadData() {
      let spinner = document.getElementById("mapSpinner");
      spinner.style.display = 'block';
      
      let constraints = Map.getConstraints(this.map);
      axios
        .get("/IOCNext/api/spatial/hydrosensors", {
          params: {
            boundaries: constraints
          }
        })
        .then(response => {
          this.sensorData = response.data;
          let spinner = document.getElementById("mapSpinner");
          spinner.style.display = 'none';
        })
        .catch(error => console.log(error));
    },
    initMap() {
      this.map = Map.initMap(50.259894, 19.016368, 13);
      Map.addTile(this.map);
      Map.addZoomControl(this.map);
      Map.addLocateControl(this.map);

      axios
        .get("/KatowiceSmall.geojson", {})
        .then(response => {
          console.log("borders receivied");
          var citiBoundaries = new L.geoJSON(response.data, {
            style: { fillOpacity: 0.08 }
          }).addTo(this.map);
        })
        .catch(error => console.log(error));

      this.airSensorClusterGroup = L.markerClusterGroup({
        spiderfyOnMaxZoom: false,
        showCoverageOnHover: false,
        zoomToBoundsOnClick: false,
        maxClusterRadius: 40,
        disableClusteringAtZoom: 10
      });
      this.map.addLayer(this.airSensorClusterGroup);

      this.map.on("moveend", () => {
        if (this.changeBouncer) clearTimeout(this.changeBouncer);
        this.changeBouncer = setTimeout(this.loadData, 1150);
      });
    }
  }
};
</script>

<style>
.my-div-icon {
  background: orange;
  border: 2px solid darkorange;
  border-radius: 5px;
  text-align: center;
  line-height: 20px;
}
.my-div-icon2 {
  background: green;
  border: 2px solid darkgreen;
  border-radius: 5px;
  text-align: center;
  line-height: 20px;
}
#map {
  height: 100vh;
  width: 100%;
  z-index: 1;
}

.leaflet-control-zoom-in {
  background-color: #e60085 !important;
  color: #ffffff !important;
  border: none !important;
  border-radius: 0px !important;
}

.leaflet-control-zoom-out {
  background-color: #e60085 !important;
  color: #ffffff !important;
  border: none !important;
  border-radius: 0px !important;
  margin-top: 5px;
}

.leaflet-bar-part-single {
  background-color: #e60085 !important;
  color: #ffffff !important;
  border: none !important;
  border-radius: 0px !important;
}

.leaflet-control-zoom {
  border: none !important;
  border-radius: 0px !important;
  margin-top: 5em !important;
}

.leaflet-bar {
  border: none !important;
  border-radius: 0px !important;
}

.popup-panel {
  position: fixed;
  bottom: 54px;
  width: 100%;
  height: auto;
  background-color: #fff;
  z-index: 500;
  display: none;
  overflow: hidden;
}

.popup-panel-pointer {
  position: fixed;
  width: 0;
  height: 0;
  border-left: 20px solid transparent;
  border-right: 20px solid transparent;
  border-bottom: 20px solid transparent;
  left: 50%;
  margin-left: -16px;
  margin-top: -20px;
  z-index: 500;
}

.v-dialog__content {
  z-index: 700 !important;
}

.map-spinner {
  position:fixed;
  left: 50%;
  top: 50%;
  margin-left: -40px;
  marign-top: -80px;
  font-size:80px;
  color:#e60085;
  z-index: 600;
  display: none;
  opacity: 0.5;
}
</style>
